import { Grid, styled } from '@mui/material'

export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};

  &.MuiGrid-item {
    margin: ${props => props.margin};
  }

  &.barChart-container {
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &.CardGridWrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  padding: ${props => props.padding};
  text-align: ${props => props.align};
`

export const ContractNumberLabel = styled('label')`
  color: ${props => props.theme.palette.brand.white};
  background-color: ${props => props.theme.palette.brand.primary};
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 50%;
  margin-left: 8px;
`
